import React from 'react';

const STACK = [
  {
    name: 'Kaggle',
    eyebrow: 'DATASETS',
    accent: '#22d3ee',
    icon: '◉',
    blurb: 'Pull benchmark datasets, competition tables, and raw training material into your research flow.',
    points: ['Public datasets', 'Competition benchmarks', 'Discovery at scale'],
  },
  {
    name: 'Hugging Face',
    eyebrow: 'MODELS',
    accent: '#fbbf24',
    icon: '⬢',
    blurb: 'Start from pretrained models, checkpoints, embeddings, and open building blocks.',
    points: ['Model hub', 'Open checkpoints', 'Inference-ready assets'],
  },
  {
    name: 'Jorvex',
    eyebrow: 'ANALYSIS + EXPERIMENTS',
    accent: '#4ade80',
    icon: '✦',
    blurb: 'Turn datasets into structured analysis, apply ML/DL experiments, reports, and saved workflows.',
    points: ['Auto EDA', 'ML and DL experiments', 'Reports, DAGs, saved workspaces'],
  },
];

function StackCard({
  item,
  mono,
  surface,
  voidBg,
  border,
  text,
  muted,
  showActions,
  primaryLabel,
  onPrimaryAction,
  secondaryLabel,
  onSecondaryAction,
}) {
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 8,
        padding: '16px 14px',
        background: `linear-gradient(180deg, ${item.accent}14 0%, ${surface} 68%, ${voidBg} 100%)`,
        border: `1px solid ${item.accent}33`,
        boxShadow: `0 18px 44px ${item.accent}10`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          background: `radial-gradient(circle at top left, ${item.accent}22, transparent 44%)`,
        }}
      />
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 }}>
          <span style={{ fontFamily: mono, fontSize: 8, color: item.accent, fontWeight: 800, letterSpacing: '.16em' }}>
            {item.eyebrow}
          </span>
          <span style={{ fontSize: 14, color: item.accent }}>{item.icon}</span>
        </div>

        <div style={{ fontFamily: 'Syne, sans-serif', fontSize: 22, fontWeight: 800, color: text, marginBottom: 8, lineHeight: 1.05 }}>
          {item.name}
        </div>

        <div style={{ fontSize: 11, color: muted, lineHeight: 1.7, marginBottom: 12 }}>
          {item.blurb}
        </div>

        <div style={{ display: 'grid', gap: 7 }}>
          {item.points.map((point) => (
            <div
              key={point}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 9px',
                borderRadius: 4,
                border: `1px solid ${item.accent}26`,
                background: `${item.accent}10`,
              }}
            >
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: item.accent, boxShadow: `0 0 12px ${item.accent}55` }} />
              <span style={{ fontFamily: mono, fontSize: 9, color: text }}>{point}</span>
            </div>
          ))}
        </div>

       
      </div>
    </div>
  );
}

export default function JorvexStackRow({
  mono = 'JetBrains Mono, monospace',
  surface = '#0a1120',
  voidBg = '#020508',
  border = '#1e293b',
  text = '#e2e8f0',
  muted = '#b6c3d8',
  showActions = false,
  primaryLabel = 'SIGN UP TO USE',
  onPrimaryAction,
  secondaryLabel = 'LOGIN',
  onSecondaryAction,
}) {
  return (
    <div className="jorvex-stack-row" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 10 }}>
      {STACK.map((item) => (
        <StackCard
          key={item.name}
          item={item}
          mono={mono}
          surface={surface}
          voidBg={voidBg}
          border={border}
          text={text}
          muted={muted}
          showActions={showActions}
          primaryLabel={primaryLabel}
          onPrimaryAction={onPrimaryAction}
          secondaryLabel={secondaryLabel}
          onSecondaryAction={onSecondaryAction}
        />
      ))}
    </div>
  );
}